import {
  CSVFileIcon,
  ExcelFileIcon,
  GenericFileIcon,
  JPGFileIcon,
  PDFFileIcon,
  PNGFileIcon,
  WordDocFileIcon,
} from '../components/Icon';

/**
 * Returns the appropriate file icon component based on the file extension.
 * Falls back to GenericFileIcon for unsupported file types.
 */
export function getFileIconForExtension(fileName: string, size: number, ariaLabel: string) {
  const extension = fileName.split('.').pop()?.toLowerCase() || '';

  switch (extension) {
    case 'pdf':
      return (
        <PDFFileIcon
          ariaLabel={ariaLabel}
          size={size}
        />
      );
    case 'doc':
    case 'docx':
      return (
        <WordDocFileIcon
          ariaLabel={ariaLabel}
          size={size}
        />
      );
    case 'xls':
    case 'xlsx':
      return (
        <ExcelFileIcon
          ariaLabel={ariaLabel}
          size={size}
        />
      );
    case 'csv':
      return (
        <CSVFileIcon
          ariaLabel={ariaLabel}
          size={size}
        />
      );
    case 'jpg':
    case 'jpeg':
      return (
        <JPGFileIcon
          ariaLabel={ariaLabel}
          size={size}
        />
      );
    case 'png':
      return (
        <PNGFileIcon
          ariaLabel={ariaLabel}
          size={size}
        />
      );
    default:
      return (
        <GenericFileIcon
          ariaLabel={ariaLabel}
          size={size}
        />
      );
  }
}
